import React, { useState } from "react";
import { AgMemberLayoutJSON } from "../Json/AgMemberLayout";
import { AgMemberFieldsJSON } from "../Json/AgMemberFields";
import { renderElement } from "../../../Components/Common/FormRendererV2/Renderer";
import { useSelector } from "react-redux";
import { CardBody, CardFooter } from "reactstrap";
import "../AgMember.scss";
import TabsFooter from "./TabsFooter";
import { Button } from "react-bootstrap";
import { formState } from "../Json/AgMemberJson";

const index = () => {
  // const formState = useSelector((state) => state.common.formRendererState);
  const [index, setIndex] = useState(0);

  const handleNext = () => {
    if (index < AgMemberLayoutJSON.length - 1) {
      setIndex(index + 1);
    }
  };

  const handlePrevious = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  const handleFinish = () => {
    // Handle finish action here
  };

  return (
    <div className="page-content">
      <div className="profile-wrapper">
        <div className="selected-tab-bottom-content">
          <div className="tab">
            <div className="tab-item">
              {AgMemberLayoutJSON.map((element, ind) => (
                <div key={element.elementid}>
                  <div
                    className={`nav-link ${index === ind ? "active" : ""}`}
                    onClick={() => setIndex(ind)}
                  >
                    {renderElement(
                      element,
                      AgMemberFieldsJSON,
                      formState,
                      {},
                      () => {
                        setIndex(ind);
                      }
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="form-fields">
              {AgMemberLayoutJSON[index]?.child?.map((it) =>
                renderElement(it, AgMemberFieldsJSON, formState, {})
              )}
            </div>
          </div>
        </div>
        <div className="navigation-buttons">
          <Button
            color="primary previous"
            onClick={handlePrevious}
            disabled={index === 0}
          >
            Previous
          </Button>
          {index === AgMemberLayoutJSON.length - 1 ? (
            <Button color="success finish" onClick={handleFinish}>
              Finish
            </Button>
          ) : (
            <Button
              color="primary next"
              onClick={handleNext}
              disabled={index === AgMemberLayoutJSON.length - 1}
            >
              Next
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default index;
